//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscGraphBox(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 7H11V17H13V7Z" fill="currentColor" /><path d="M17 10H15V17H17V10Z" fill="currentColor" /><path d="M9 13H7V17H9V13Z" fill="currentColor" /><path d="M3 3V21H21V3H3ZM19 19H5V5H19V19Z" fill="currentColor" /></svg>;
}
export default IconMiscGraphBox;